var _circle, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankDarkmode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bank-dark_mode",
    "data-name": "bank-dark mode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 3)",
    fill: "#b5bac1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34597",
    "data-name": "Path 34597",
    d: "M1.125,7.031h15.75a1.125,1.125,0,0,0,.584-2.087L9.584.163a1.125,1.125,0,0,0-1.168,0L.541,4.945a1.125,1.125,0,0,0,.584,2.087ZM9,2.531A1.406,1.406,0,1,1,7.594,3.938,1.406,1.406,0,0,1,9,2.531Z",
    transform: "translate(0)",
    fill: "#b5bac1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5952",
    "data-name": "Rectangle 5952",
    width: 2,
    height: 7,
    transform: "translate(9.999 8)",
    fill: "#b5bac1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5953",
    "data-name": "Rectangle 5953",
    width: 2,
    height: 7,
    transform: "translate(12.999 8)",
    fill: "#b5bac1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5954",
    "data-name": "Rectangle 5954",
    width: 2,
    height: 7,
    transform: "translate(6 8)",
    fill: "#b5bac1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5955",
    "data-name": "Rectangle 5955",
    width: 2,
    height: 7,
    transform: "translate(3 8)",
    fill: "#b5bac1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34598",
    "data-name": "Path 34598",
    d: "M4,55.125H19.75A1.125,1.125,0,0,0,18.625,54H5.125A1.125,1.125,0,0,0,4,55.125Z",
    transform: "translate(-2.875 -38.813)",
    fill: "#b5bac1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34599",
    "data-name": "Path 34599",
    d: "M17.844,60H.156A1.113,1.113,0,0,0,0,60.563v.563H18v-.562A1.113,1.113,0,0,0,17.844,60Z",
    transform: "translate(0 -43.125)",
    fill: "#b5bac1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDarkmode1);
export default __webpack_public_path__ + "static/media/bank-dark mode (1).68226ca9ad72b8ab9fd08f40c6d14f01.svg";
export { ForwardRef as ReactComponent };